import React, { useEffect, useRef, useState } from "react";
import DesktopBackground from "../../../assets/landingPage/landingBackground.webp";
import DesktopBackground1 from "../../../assets/landingPage/landingBackground1.webp";
import DesktopBackground2 from "../../../assets/landingPage/landingBackground2.webp";
import DesktopBackground3 from "../../../assets/landingPage/landingBackground3.webp";
import DesktopBackground4 from "../../../assets/landingPage/landingBackground4.webp";
import DesktopBackground5 from "../../../assets/landingPage/landingBackground5.webp";
import DesktopBackground6 from "../../../assets/landingPage/landingBackground6.webp";
import DesktopBackground7 from "../../../assets/landingPage/landingBackground7.webp";
import DesktopBackground8 from "../../../assets/landingPage/landingBackground8.webp";
import { Image } from "react-native";
import { ids, styles } from "./HomeCss.js";
import * as Animatable from "react-native-animatable";

const CarousalView = () => {
  const elements = [
    DesktopBackground,
    DesktopBackground1,
    DesktopBackground2,
    DesktopBackground3,
    DesktopBackground4,
    DesktopBackground5,
    DesktopBackground6,
    DesktopBackground7,
    DesktopBackground8,
  ];
  const [currentBackgroundIndex, setCurrentBackgroundIndex] = useState(0);
  const isMounted = useRef(true);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (isMounted.current) {
        setCurrentBackgroundIndex(
          (prevIndex) => (prevIndex + 1) % elements.length
        );
      }
    }, 2000);

    return () => {
      isMounted.current = false;
      clearInterval(intervalId);
    };
  }, [elements.length]);
  const fadeInOut = {
    0: {
      opacity: 1,
    },
    0.2: {
      opacity: 0.8,
    },
    0.34: {
      opacity: 0.7,
    },
    0.88: {
      opacity: 0.8,
    },
    1: {
      opacity: 1,
    },
  };

  return (
    <Animatable.View
      direction="reverse"
      iterationCount="infinite"
      animation={fadeInOut}
      duration={2000}
      delay={500}
    >
      {elements?.map((image, index) => (
        <Image
          key={index}
          source={image}
          style={[styles.imageBackground, { display: "none" }]}
        />
      ))}
      <Image
        source={elements[currentBackgroundIndex]}
        style={styles.imageBackground}
      />
    </Animatable.View>
  );
};

export default CarousalView;
